import { Hammer } from "lucide-react";
import ServicePage from "./ServicePage";

const faqs = [
  {
    q: "Wat valt er onder een complete renovatie?",
    a: "Alles wat nodig is om uw woning van A tot Z te vernieuwen: sloopwerk, indeling, stucwerk, tegelwerk, badkamer, keuken, vloeren, timmerwerk, schilderwerk en – via onze vaste partners – elektra en installaties. U heeft één aanspreekpunt voor het hele traject.",
  },
  {
    q: "Hoe lang duurt een complete woningrenovatie?",
    a: "Afhankelijk van de grootte en de staat van de woning gemiddeld 6 tot 16 weken. Vooraf ontvangt u een gedetailleerde planning en tijdens de renovatie houden wij u wekelijks op de hoogte van de voortgang.",
  },
  {
    q: "Wat kost een complete renovatie?",
    a: "De kosten hangen af van de oppervlakte, de staat van de woning en uw materiaalkeuze. Na een vrijblijvende opname bij u thuis ontvangt u een transparante offerte per onderdeel, zodat u precies weet waar u aan toe bent.",
  },
  {
    q: "In welke regio voeren jullie complete renovaties uit?",
    a: "Vanuit onze vestiging in Breukelen werken wij in heel Noord-Holland, Zuid-Holland, Utrecht en Flevoland. Denk aan Amsterdam, Utrecht, Rotterdam, Den Haag, Hilversum, Amersfoort, Almere, Haarlem en Leiden.",
  },
  {
    q: "Kan ik tijdens de renovatie in de woning blijven wonen?",
    a: "Bij een gedeeltelijke renovatie is dat vaak mogelijk. Bij een totaalrenovatie adviseren wij meestal om tijdelijk elders te verblijven; dit werkt sneller, veiliger en goedkoper. Wij bespreken dit vooraf met u.",
  },
  {
    q: "Kunnen jullie ook energiebesparende maatregelen meenemen?",
    a: "Ja. Denk aan isolatie van dak, gevel en vloer, HR++ glas en kierdichting. Een renovatie is het ideale moment om uw woning energiezuiniger te maken. Wij adviseren graag over de mogelijkheden.",
  },
];

export default function CompleteRenovatiePage() {
  return (
    <ServicePage
      seoTitle="Complete Renovatie | Noord-Holland, Zuid-Holland, Utrecht & Flevoland - Cardoso Bouw"
      seoDescription="Complete woningrenovatie door Cardoso Bouw en Onderhoud uit Breukelen. Totaalrenovaties van woningen, appartementen en bedrijfspanden in Noord-Holland, Zuid-Holland, Utrecht en Flevoland. 8+ jaar ervaring, 9 vakmannen."
      seoKeywords="complete renovatie, totaalrenovatie, woning renovatie, huis renoveren, verbouwing, complete renovatie Breukelen, complete renovatie Utrecht, renovatie Noord-Holland, renovatie Zuid-Holland, renovatie Flevoland, complete renovatie Loosdrecht, renovatie Amsterdam, renovatie Hilversum"
      title="Complete Renovatie"
      subtitle="Complete renovatie in Noord-Holland, Zuid-Holland, Utrecht en Flevoland"
      heroImage="https://customer-assets.emergentagent.com/job_cardoso-bouw/artifacts/t3bzg8ue_IMG_0034.jpeg"
      icon={Hammer}
      description="Bent u op zoek naar een betrouwbare partij voor een complete renovatie? Cardoso Bouw en Onderhoud uit Breukelen is uw specialist in totaalrenovaties in Noord-Holland, Zuid-Holland, Utrecht en Flevoland. Wij renoveren woningen, appartementen en bedrijfspanden van A tot Z. Met meer dan 8 jaar ervaring en een team van 9 vakmannen garanderen wij een professioneel resultaat."
      features={[
        "Volledige woningrenovatie",
        "Keukenrenovatie",
        "Badkamerrenovatie",
        "Vloeren en wanden",
        "Stucwerk en schilderwerk",
        "Timmerwerk en kozijnen",
        "Elektra en leidingwerk (via partners)",
        "Isolatie en energiebesparing",
      ]}
      faqs={faqs}
      extraContent={
        <div className="space-y-6">
          <h2 className="font-['Barlow_Condensed'] text-2xl font-bold uppercase text-[#0F172A]">
            Waarom kiezen voor een complete renovatie?
          </h2>
          <p className="text-slate-600 text-base leading-relaxed">
            Een complete renovatie biedt u de mogelijkheid om uw woning in een keer aan te pakken. 
            In plaats van losse klussen uit te besteden aan verschillende partijen, regelt Cardoso 
            Bouw en Onderhoud alles onder een dak. Dit bespaart u tijd, geld en zorgen.
          </p>
          <p className="text-slate-600 text-base leading-relaxed">
            Bij een totaalrenovatie beginnen wij met een grondige inspectie van uw woning. 
            Samen bespreken wij uw wensen en stellen wij een gedetailleerd plan op. 
            Vervolgens coördineren wij alle werkzaamheden: van sloopwerk en stucwerk 
            tot schilderwerk en timmerwerk. U heeft een vast aanspreekpunt gedurende 
            het hele traject.
          </p>

          <h3 className="font-['Barlow_Condensed'] text-xl font-bold uppercase text-[#0F172A]">
            Complete renovatie in vier provincies
          </h3>
          <p className="text-slate-600 text-base leading-relaxed">
            Vanuit onze vestiging in Breukelen voeren wij complete renovaties uit in heel 
            Noord-Holland, Zuid-Holland, Utrecht en Flevoland. Of u nu een jaren 30 woning 
            wilt renoveren in Hilversum, een appartement in Amsterdam of Rotterdam, of een 
            vrijstaande woning in Almere of Amersfoort: wij komen graag bij u langs voor 
            een vrijblijvende offerte.
          </p>

          <h3 className="font-['Barlow_Condensed'] text-xl font-bold uppercase text-[#0F172A]">
            Ons renovatieproces
          </h3>
          <p className="text-slate-600 text-base leading-relaxed">
            Elke complete renovatie begint met een vrijblijvend adviesgesprek bij u thuis. 
            Wij nemen de situatie op en bespreken uw plannen. Daarna ontvangt u een 
            gedetailleerde offerte met een duidelijke planning. Tijdens de renovatie 
            houden wij u wekelijks op de hoogte van de voortgang. Na oplevering doen 
            wij samen een eindcontrole om ervoor te zorgen dat alles naar wens is.
          </p>
          <p className="text-slate-600 text-base leading-relaxed">
            Wij werken uitsluitend met hoogwaardige materialen van bekende merken. 
            Onze vakmannen zijn ervaren in alle aspecten van renovatiewerk: stucwerk, 
            schilderwerk, tegelwerk, timmerwerk en meer. Zo bent u verzekerd van een 
            duurzaam en mooi resultaat.
          </p>

          <h3 className="font-['Barlow_Condensed'] text-xl font-bold uppercase text-[#0F172A]">
            Wat kost een complete renovatie?
          </h3>
          <p className="text-slate-600 text-base leading-relaxed">
            De kosten van een complete renovatie zijn afhankelijk van de grootte van 
            het project, de materialen en uw specifieke wensen. Wij stellen altijd 
            een transparante offerte op zodat u precies weet waar u aan toe bent. 
            Vraag vandaag nog een vrijblijvende offerte aan en ontdek wat wij voor 
            uw woning kunnen betekenen.
          </p>
        </div>
      }
    />
  );
}
